module.exports = __webpack_public_path__ + "static/media/gallaxy-background-web.e0d7cf38.webp";